import {
    updateFilters,
    setEnabledFilters
} from '@zoopla/redux-reducer-filters';
import { initialiseSortOrder } from '@zoopla/redux-reducer-sort-order';
import {
    updateTotalResults,
    updatePageNumber,
    updatePageNumberMax,
    updateTotalResultsWasLimited,
    updatePolyenc
} from '@zoopla/redux-reducer-search-results';
import { initialiseReduxFilters } from './initialiseFilters';

import { Store } from 'redux';
import { ParsedUrlQuery } from 'querystring';
import { RawSortOrderOption } from '@zoopla/redux-types';
import { RawFilter } from '@zoopla/redux-types';

type DispatchData = {
    sortOrder: {
        currentSortOrder: string;
        options: RawSortOrderOption[];
    };
    totalResults: number;
    pageNumber: number;
    pageNumberMax: number;
    totalResultsWasLimited: boolean;
    polyenc: string | null;
    filtersFields: RawFilter[];
};

export const dispatchData = (
    store: Store,
    data: DispatchData,
    query: ParsedUrlQuery
) => {
    const {
        sortOrder,
        totalResults,
        pageNumber,
        pageNumberMax,
        totalResultsWasLimited,
        polyenc,
        filtersFields
    } = data;

    store.dispatch(initialiseSortOrder(sortOrder));
    store.dispatch(updateTotalResults(totalResults));
    store.dispatch(updatePageNumber(pageNumber));
    store.dispatch(updatePageNumberMax(pageNumberMax));
    store.dispatch(updateTotalResultsWasLimited(totalResultsWasLimited));
    store.dispatch(updatePolyenc(polyenc));

    const filtersFormatted = initialiseReduxFilters(filtersFields, query);

    store.dispatch(updateFilters(filtersFormatted));
    store.dispatch(setEnabledFilters());
};
